import React from 'react';
import { stats } from '../data/content';
export function StatsStrip() {
  return <section aria-label="Cricket Ready by the numbers" className="bg-navy-900 px-5 py-8" data-id="element-201" data-mp="ghf6m9pssr4h">
      <div className="mx-auto grid max-w-4xl grid-cols-2 gap-6 rounded-2xl border border-white/10 bg-navy-700 px-6 py-7 sm:grid-cols-4" data-id="element-202" data-mp="2ifg0wiq625o">
        {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-203" data-mp="7itp8hw2bi5a">
            <p className="font-display text-2xl font-black text-gold sm:text-3xl" data-id="element-204" data-mp="v7w63nivh6yq">
              {stat.value}
            </p>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-white/55 sm:text-xs" data-id="element-205" data-mp="107qwlpyqjuj9">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}